export default {
  
  setIndexUserGroups(state, result) {
    state.indexUserGroups = result;
  },

  setAssetUserGroups(state, result) {
    state.assetUserGroups = result;
  },

  setUserGroupEntityAssignmentInput(state, result) {
    state.userGroupEntityAssignmentInput = result;
  },
};
